import React, { useEffect, useState } from 'react'
import AdsNavbar from '../AdsNavbar.jsx'
import Loader from '../../../../components/Loader'
import Calling from '../../../../api/Calling';
import { toast } from 'react-toastify';
import NotFound from '../../../../components/ul/NotFound';
import TopNavbar from '../../TopNavbar.jsx';

const IosFullScreenAds = () => {
    const [loader, setLoader] = useState(false);
    const [nativeAds, setNativeAds] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [showAddForm, setShowAddForm] = useState(false);
    const [newAd, setNewAd] = useState({ a_name: '', a_id: '', a_description: '' });
    const [searchTerm, setSearchTerm] = useState('');

    const fetchData = async () => {
        setLoader(true);
        try {
            const resp = await Calling.getIosFullScreenAds();
            if (resp?.status) {
                setNativeAds(resp?.data);
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    // Function to handle search input change
    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    }

    // Filtered nativeAds based on searchTerm
    const filteredAds = nativeAds.filter(ad =>
        ad.a_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ad.a_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ad.a_description.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleEdit = (id) => {
        setEditingId(id);
    }

    const handleSave = async (id) => {
        const adToUpdate = nativeAds.find(ad => ad._id === id);
        setLoader(true)
        try {
            const resp = await Calling.updateIosFullScreenAds(id, {
                a_id: adToUpdate.a_id,
                a_description: adToUpdate?.a_description
            });
            if (resp?.status) {
                toast.success(resp?.message);
                fetchData();
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
            setEditingId(null);
        }
    }

    const handleInputChange = (id, field, value) => {
        setNativeAds(nativeAds.map(item =>
            item._id === id ? { ...item, [field]: value } : item
        ));
    }

    const handleAddSubmit = async () => {
        if (newAd.a_name.trim() === '' || newAd.a_id.trim() === '' || newAd.a_description.trim() === '') {
            toast.error('Please fill all the fields');
            return;
        }

        setLoader(true);
        try {
            const body = {
                a_name: newAd.a_name.replace(/ /g, ''),
                a_id: newAd.a_id.replace(/ /g, ''),
                a_description: newAd.a_description
            }
            const resp = await Calling.addIosFullScreenAds(body);
            if (resp?.status) {
                toast.success(resp?.message);
                setNewAd({ a_name: '', a_id: '', a_description: '' });
                setShowAddForm(false);
                fetchData();
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    }

    return (
        <>
            {loader ? (
                <Loader />
            ) : (
                <div className="w-full min-h-screen text-main-font">
                    {/* Page Header */}
                    <div className="mb-6">
                        <div className="flex items-center gap-3">
                            <div className="p-2.5 rounded-xl bg-blue-600 text-main-white">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <div>
                                <h1 className="text-2xl font-bold text-main-font">Ad Management</h1>
                                <p className="text-sm text-main-subfont">Manage and configure your advertisements</p>
                            </div>
                        </div>
                    </div>

                    {/* Main Card */}
                    <div className="bg-main-white rounded-2xl shadow-sm border border-main-border overflow-hidden">
                        <TopNavbar selectState={'ios'} />
                        <hr className="border-main-border" />
                        <AdsNavbar selectState={'fsads'} />
                        <hr className="border-main-border" />

                        {/* Header with Add button */}
                        <div className="px-4 py-4">
                            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
                                <h2 className="text-lg font-semibold text-main-font">Full Screen Ads (iOS)</h2>

                                {/* Action Buttons */}
                                <div className="flex flex-wrap gap-2">
                                    <button
                                        onClick={() => setShowAddForm(!showAddForm)}
                                        className={`px-4 py-2.5 text-sm text-white rounded-xl transition-colors flex items-center gap-2 font-medium ${showAddForm ? 'bg-yellow-500 hover:bg-yellow-600' : 'bg-green-600 hover:bg-green-700'}`}
                                    >
                                        {showAddForm ? (
                                            <>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                                </svg>
                                                Cancel Add
                                            </>
                                        ) : (
                                            <>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                                </svg>
                                                Add FS Ads
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>

                            {/* Add Ad Form */}
                            {showAddForm && (
                                <div className="p-4 rounded-xl space-y-4 bg-gray-50 border border-gray-200 mb-4">
                                    <div className="flex items-center gap-2 mb-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                        </svg>
                                        <h3 className="text-base font-medium text-main-font">Add New Full Screen Ad</h3>
                                    </div>

                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                        <div className="flex flex-col gap-2">
                                            <label className="text-sm text-main-subfont font-medium">Ad Name:</label>
                                            <input
                                                type="text"
                                                placeholder="Ad Name"
                                                value={newAd.a_name}
                                                onChange={(e) => setNewAd({ ...newAd, a_name: e.target.value })}
                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 focus:outline-none transition-all"
                                            />
                                        </div>
                                        <div className="flex flex-col gap-2">
                                            <label className="text-sm text-main-subfont font-medium">Ad ID:</label>
                                            <input
                                                type="text"
                                                placeholder="Ad ID"
                                                value={newAd.a_id}
                                                onChange={(e) => setNewAd({ ...newAd, a_id: e.target.value })}
                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 focus:outline-none transition-all"
                                            />
                                        </div>
                                    </div>

                                    <div className="flex flex-col gap-2">
                                        <label className="text-sm text-main-subfont font-medium">Description:</label>
                                        <textarea
                                            placeholder="Ad Description"
                                            value={newAd?.a_description}
                                            onChange={(e) => setNewAd({ ...newAd, a_description: e.target.value })}
                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 focus:outline-none transition-all"
                                            rows={3}
                                        />
                                    </div>

                                    <div className="flex gap-3 pt-2">
                                        <button
                                            onClick={handleAddSubmit}
                                            className="px-4 py-2.5 text-sm text-main-white bg-main-blue rounded-xl hover:bg-main-blue/80 transition-colors flex items-center gap-2 font-medium"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                            </svg>
                                            Submit
                                        </button>
                                        <button
                                            onClick={() => {
                                                setShowAddForm(false);
                                                setNewAd({ a_name: '', a_id: '', a_description: '' });
                                            }}
                                            className="px-4 py-2.5 text-sm text-main-delete border border-main-delete bg-main-white rounded-xl hover:bg-main-delete/10 transition-colors flex items-center gap-2 font-medium"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Search Bar */}
                        <div className="px-4 pb-4">
                            <div className="relative w-full lg:w-80">
                                <svg xmlns="http://www.w3.org/2000/svg" className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-main-subfont" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                                <input
                                    type="text"
                                    placeholder="Search Ads..."
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    className="w-full pl-11 pr-4 py-2.5 border border-main-border rounded-xl bg-main-bg focus:bg-main-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 focus:outline-none transition-all text-sm"
                                />
                            </div>
                        </div>

                        {/* Table */}
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead>
                                    <tr className="bg-main-th">
                                        <th className="px-4 py-4 text-left text-xs font-semibold text-main-subfont uppercase tracking-wider">No</th>
                                        <th className="px-4 py-4 text-left text-xs font-semibold text-main-subfont uppercase tracking-wider">Ad Name</th>
                                        <th className="px-4 py-4 text-left text-xs font-semibold text-main-subfont uppercase tracking-wider">Ad ID</th>
                                        <th className="px-4 py-4 text-left text-xs font-semibold text-main-subfont uppercase tracking-wider">Description</th>
                                        <th className="px-4 py-4 text-center text-xs font-semibold text-main-subfont uppercase tracking-wider">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-main-border">
                                    {filteredAds.length > 0 ?
                                        filteredAds?.map((item, index) => (
                                            <tr key={index} className="hover:bg-main-thHover transition-colors">
                                                <td className="px-4 py-4 text-sm text-main-font">{index + 1}</td>
                                                <td className="px-4 py-4 text-sm font-medium text-main-font">{item.a_name}</td>
                                                <td className="px-4 py-4 text-sm">
                                                    {editingId === item._id ? (
                                                        <input
                                                            type="text"
                                                            value={item.a_id}
                                                            onChange={(e) => handleInputChange(item._id, 'a_id', e.target.value)}
                                                            className="px-4 py-2 w-full border border-main-border rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none text-sm transition-all"
                                                        />
                                                    ) : (
                                                        <span className="text-sm text-main-subfont break-all">{item.a_id}</span>
                                                    )}
                                                </td>
                                                <td className="px-4 py-4 text-sm">
                                                    {editingId === item._id ? (
                                                        <textarea
                                                            value={item.a_description}
                                                            onChange={(e) => handleInputChange(item._id, 'a_description', e.target.value)}
                                                            className="px-4 py-2 w-full border border-main-border rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none text-sm transition-all"
                                                        />
                                                    ) : (
                                                        <span className="text-sm text-main-subfont break-all">{item.a_description}</span>
                                                    )}
                                                </td>
                                                <td className="px-4 py-4 text-center">
                                                    <div className="flex justify-center gap-2">
                                                        <button
                                                            onClick={() => editingId === item._id ? handleSave(item._id) : handleEdit(item._id)}
                                                            className={`px-3 py-1.5 text-xs text-main-white rounded-lg transition-colors font-medium ${editingId === item._id
                                                                ? 'bg-green-500 hover:bg-green-600'
                                                                : 'bg-main-blue hover:bg-main-blue/80'
                                                                }`}
                                                        >
                                                            {editingId === item._id ? 'Save' : 'Edit'}
                                                        </button>
                                                        {editingId === item._id && (
                                                            <button
                                                                onClick={() => setEditingId(null)}
                                                                className="px-3 py-1.5 text-xs font-medium text-main-white bg-red-500 hover:bg-red-600 rounded-lg transition-colors"
                                                            >
                                                                Cancel
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                        :
                                        <tr><td className="text-center py-12" colSpan={5}><NotFound /></td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default IosFullScreenAds